import 'jquery-modal';
// import URI from 'uri.js';
import { enableBodyScroll, disableBodyScroll } from 'body-scroll-lock';
import { closeSliderCart } from '../../sections/slider-cart';
import getProductURL from '../../core/productURL';
import loadProductsByID from '../../core/storefrontAPI/load-product-by-id';
import loadMetaobject from '../../core/storefrontAPI/load-metaobject';
import { getFitsOptions, getColorOptions, getSizesOptions, getSizesOptionsList, initProductOptions, selectColorQuicklook, selectSizeQuicklook, getSameColorVariants, getProductPrice } from './product-options';
import productExtra from './product-extra-v3';
import variantImages from './variant-images';
import { getRating, getAfterpay, getWishlistButton } from './third-parties';
import { initWishlist, initWishlistQuickviewOpen, initWishlistQuickviewMobileOpen } from '../../components/wishlist/quicklook';
import { nostoRecommendedProductViewEvent, nostoRecordSearchClickEvent } from '../../components/nosto/events';
import TabsAutomatic from '../../components/tabs';

const loadProductDetailsFromStorefrontAPI = async (product_id) => {
  try {
    console.log(`Load product details with ID ${product_id}`);
    const product_data = await loadProductsByID([product_id], true, true, true, true, true, true, true);

    if (!product_data.length) {
      return null;
    }
    
    return product_data[0].node;
  } catch (error) {
    console.log('Product loading error', error);
    return null;
  }
};

// Not in quickview this way (modal in modal)
/*
const getSizeGuide = () => {
  return `
    <div class="product-size-info">
      <div class="product-size-info__guide" data-modal="#size-guide-modal" tabindex="0" role="button">
        <svg width="33px" height="16px" viewBox="0 0 33 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <title>Icon Guide</title>
          <defs></defs>
          <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g class="icon-guide__fill" transform="translate(-771.000000, -532.000000)" fill="#231F20">
                  <g transform="translate(769.000000, 185.000000)">
                      <g transform="translate(0.000000, 268.000000)">
                          <path d="M2,95 L35,95 L35,79 L2,79 L2,95 Z M28.191213,87.0005146 L28.191213,80.0292699 L34.0123605,80.0292699 L34.0123605,93.9707301 L2.98763954,93.9707301 L2.98763954,80.0292699 L8.73372639,80.0292699 L8.73372639,91.4459312 L9.7203783,91.4459312 L9.7203783,80.0292699 L14.6862299,80.0292699 L14.6862299,87.0005146 L15.6748571,87.0005146 L15.6748571,80.0292699 L21.2500823,80.0292699 L21.2500823,91.4459312 L22.2377218,91.4459312 L22.2377218,80.0292699 L27.2035735,80.0292699 L27.2035735,87.0005146 L28.191213,87.0005146 Z"></path>
                      </g>
                  </g>
              </g>
          </g>
        </svg><span>SIZE GUIDE</span>
      </div>
    </div>
  `;
};
*/

const getActions = (product, current_variant, edit_mode = false) => {
  let html = '';

  if (edit_mode) {
    return `
      <div class="product-actions">
        <div class="product-actions__update-container">
          <button
            class="btn btn--primary product-actions__update"
            type="submit"
            name="update"
            data-quickview-update
            data-replace="false"
            aria-label="Update"
            tabindex="0">
              <span>Update</span>
          </button>
        </div>
      </div>
    `;
  }

  let add_to_bag_bt = `<span data-quickview-add-to-cart-available>${window.theme.strings.addToCart}</span>`;
  let sold_out_bt = `<span data-quickview-add-to-cart-unavailable>${window.theme.strings.soldOut}</span>`;

  if (current_variant.availableForSale == true) {
    sold_out_bt = `<span data-quickview-add-to-cart-unavailable class="visually-hidden" tabindex="-1" aria-hidden="true">${window.theme.strings.soldOut}</span>`;
  } else {
    add_to_bag_bt = `<span data-quickview-add-to-cart-available class="visually-hidden" tabindex="-1" aria-hidden="true">${window.theme.strings.addToCart}</span>`;
  }

  // const buy_now_button = `
  //   <div class="product-actions__buy-now-container" data-quickview-buy-now-container>
  //     <button
  //       class="btn btn--secondary product-actions__buy-now"
  //       type="button"
  //       name="buy-now"
  //       data-quickview-buy-now
  //       data-replace="false"
  //       aria-label="${window.theme.strings.buyNow}"
  //       disabled="disabled"
  //       tabindex="0">
  //         <span data-buy-now-text>${window.theme.strings.buyNow}</span>
  //     </button>
  //   </div>
  // `;
  const buy_now_button = '';

  html = `
    <div class="product-actions">
      <div class="product-actions__add-to-cart-container">
        <button
          class="btn btn--primary product-actions__add-to-cart"
          type="submit"
          name="add"
          data-quickview-add-to-cart
          data-replace="false"
          aria-label="${window.theme.strings.addToCart}"
          disabled="disabled"
          tabindex="0">
            <span data-quickview-add-to-cart-text>
              ${add_to_bag_bt}
              ${sold_out_bt}
            </span>
        </button>

        ${(window.theme.breakpoints.current === 'mobile') ? '' : buy_now_button}
        ${(window.theme.breakpoints.current === 'mobile') ? '' : getWishlistButton(product, current_variant)}
      </div>
    </div>
  `;

  return html;
};

const getFinalSale = (product_data) => {
  const tags_string = (typeof product_data.tags === 'undefined' || product_data.tags === null) ? '' : product_data.tags.join(',').toLowerCase();

  let final_sale = '<p class="product-details__message" data-message="final-sale">Final Sale</p>';

  // Disabled - Now prepended to discount message
  // final_sale += '<input type="hidden" name="properties[Note]" id="final-sale-option" value="Final Sale" data-final-sale>';

  if (tags_string.includes('final sale')) {
    if (tags_string.includes('socialclub:final sale')) {
      if (typeof window.theme.customer.id === 'undefined') {
        final_sale = '';
      }
    }
  } else {
    final_sale = '';
  }

  return final_sale;
};

const getHeavy = (product_data) => {
  const tags_string = (typeof product_data.tags === 'undefined' || product_data.tags === null) ? '' : product_data.tags.join(',').toLowerCase();

  if (tags_string.includes('big')) {
    return `<input type="hidden" name="attributes[Heavy]" id="heavy-order" value="true" data-heavy-order>`;
  }

  return '';
};

// Different promo message for logged-in/loyalty and guest customers
// Same code as collection/productTileTemplate.js
const getPromoMessageAndPrice = (product_data, data_type = 'message') => {
  const is_search = $('body').hasClass('has-overlay-search');

  // Promo applied by product tag or collection. Ignored when a promotion call out message has been defined for all products
  let promo_message = window.theme.promoMessage.guests;
  let promo_message_color = window.theme.promoMessage.color;
  let promo_discount = window.theme.promoMessage.guestPercentOff;
  let promo_discount_color = window.theme.promoMessage.colorPercentOff;
  let promo_tag = window.theme.promoMessage.tag;
  let promo_collection = window.theme.promoMessage.collection;
  let special_message = '';
  const product_collections = product_data.collections.edges.map(item => item.node.handle) || [];

  // Promo applied to all products.
  if (window.theme.promoMessage.guestsAllProducts !== '') {
    promo_message = window.theme.promoMessage.guestsAllProducts;
    promo_message_color = window.theme.promoMessage.colorAllProducts;
  }
  if (window.theme.promoMessage.guestAllProductsPercentOff !== 0) {
    promo_discount = window.theme.promoMessage.guestAllProductsPercentOff;
    promo_discount_color = window.theme.promoMessage.colorAllProductsPercentOff;
  }
  if (window.theme.promoMessage.guestsAllProducts !== '' || window.theme.promoMessage.guestAllProductsPercentOff !== 0) {
    promo_tag = '';
    promo_collection = '';
  }

  // Promo applied to loyalty members
  if (typeof window.theme.customer.id !== 'undefined') {
    promo_message = window.theme.promoMessage.loyalty;
    promo_discount = window.theme.promoMessage.loyaltyPercentOff;
    promo_discount_color = window.theme.promoMessage.colorPercentOff;

    // Promo applied to all products.
    if (window.theme.promoMessage.loyaltyAllProducts !== '') {
      promo_message = window.theme.promoMessage.loyaltyAllProducts;
      promo_message_color = window.theme.promoMessage.colorAllProducts;
    }
    if (window.theme.promoMessage.loyaltyAllProductsPercentOff !== 0) {
      promo_discount = window.theme.promoMessage.loyaltyAllProductsPercentOff;
      promo_discount_color = window.theme.promoMessage.colorAllProductsPercentOff;
    }
    if (window.theme.promoMessage.loyaltyAllProducts !== '' || window.theme.promoMessage.loyaltyAllProductsPercentOff !== 0) {
      promo_tag = '';
      promo_collection = '';
    }
  }

  // Special message
  if (window.theme.promoMessage.specialMessage !== '') {
    if (typeof window.theme.customer.id === 'undefined') {
      if (window.theme.promoMessage.specialMessageCustomers === 'guests' || window.theme.promoMessage.specialMessageCustomers === 'all') {
        special_message = window.theme.promoMessage.specialMessage;
      }
    } else if (window.theme.promoMessage.specialMessageCustomers === 'members' || window.theme.promoMessage.specialMessageCustomers === 'all') {
      special_message = window.theme.promoMessage.specialMessage;
    }
  }

  // Special message, we need to make sure it only applies to the selected collection if any
  let special_message_html = '';
  if (special_message !== '') {
    let show_special_message = false;

    if (window.theme.promoMessage.specialMessageCollection === '') {
      show_special_message = true;
    } else {
      if (!is_search) {
        if (window.theme.promoMessage.specialMessageCollection === $('[data-collection-grid]').data('collection')) {
          show_special_message = true;
        }
      }

      if (show_special_message === false) {
        for (let i = 0; i < product_collections.length; i++) {
          const collection = product_collections[i];

          if (collection === window.theme.promoMessage.specialMessageCollection) {
            show_special_message = true;
            break;
          }
        }
      }
    }

    if (show_special_message === true) {
      special_message_html = `<span class="product-tile__special-message" data-same-line="${window.theme.promoMessage.specialMessageSameLine}">${special_message}</span>`;
    }
  }

  let promo_message_html = '';

  if (data_type === 'message') {

    if (promo_message.length) {
      promo_message = `<span>${ promo_message }</span>`;
    }

    promo_message_html = `
      <p class="product-details__message" style="color: ${ promo_message_color } !important;" tabindex="0">${ promo_message }${ special_message_html }</p>
    `;
  }

  if (data_type === 'price' && promo_discount !== 0) {
    const first_variant_price = product_data?.variants?.edges[0]?.node?.price?.amount || 0;

    if (first_variant_price !== 0) {
      promo_message_html = `
        <p class="product-details__price-promo">
          <span class="product-details__promo" style="color: ${promo_discount_color} !important;">$${ parseFloat((parseFloat(first_variant_price, 10) - ((parseFloat(first_variant_price, 10) * promo_discount) / 100))).toFixed(2) } after ${ promo_discount }% off</span>
        </p>
      `;
    }
  }

  if (promo_tag === '' && promo_collection === '') {
    if (data_type === 'message' && promo_message_html === '' && special_message_html !== '') {
      return `<p class="product-details__message" style="color: ${ promo_message_color } !important;" tabindex="0">${ special_message_html }</p>`;
    }

    return promo_message_html;
  } else {
    // Message for specific tagged products or collections
    let show_promo_message = false;

    if (promo_tag !== '' && promo_collection === '') {
      for (let i = 0; i < product_data.tags.length; i++) {
        const tag = product_data.tags[i];
        if (tag.indexOf(promo_tag) !== -1) {
          show_promo_message = true;
          break;
          // return promo_message_html;
        }
      }
    } else {
      if (!is_search) {
        if (promo_collection === $('[data-collection-grid]').data('collection')) {
          show_promo_message = true;
          // return promo_message_html;
        }
      }

      if (!show_promo_message) {
        for (let i = 0; i < product_collections.length; i++) {
          const collection_handle = product_collections[i];

          if (collection_handle === promo_collection) {
            show_promo_message = true;
            break;
            // return promo_message_html;
          }
        }
      }
    }

    if (show_promo_message === true) {
      if (data_type === 'message' && promo_message_html === '' && special_message_html !== '') {
        return `<p class="product-details__message" style="color: ${ promo_message_color } !important;" tabindex="0">${ special_message_html }</p>`;
      }
      return promo_message_html;
    } else if (data_type === 'message' && special_message_html !== '') {
      return `<p class="product-details__message" style="color: ${ promo_message_color } !important;" tabindex="0">${ special_message_html }</p>`;
    }
  }

  return '';
};

// Build the html based on the extracted data from the Storefront API
const populateProductDetails = (product_data, selected_color, edit_mode = false) => {
  const $ql = $('#quicklook-modal');

  try {
    console.log(`Populate product details`, product_data);

    if (product_data === null) {
      throw new Error('[ASTR] No product data');
    }

    if (product_data.handle.includes('gift-card')) {
      throw new Error('[ASTR] Gift cards not supported');
    }

    const same_color_variants_edges = getSameColorVariants(selected_color);

    if (same_color_variants_edges === null) {
      throw new Error('[ASTR] No variants with the selected color');
    }

    const swatches_data = (product_data.astrSwatches === null) ? [] : JSON.parse(product_data.astrSwatches.value.split('\"').join('"'));
    const same_color_variants = same_color_variants_edges.map(edge => edge.node);
    const all_variants = product_data.variants.edges.map(edge => edge.node);
    const max_images = (edit_mode) ? 1 : 4;

    const $html = `
      <div class="product-scrollable" data-product-scrollable data-product-id="${product_data.id.split('/').pop()}">
        <div class="product-scrollable__images" data-product-scrollable-images>
          ${(product_data.images === null || typeof product_data.images.edges === 'undefined' || !product_data.images.edges.length) ? '' : variantImages(same_color_variants[0], max_images)}
        </div>

        <div class="product-scrollable__details" data-product-scrollable-details>
          <hgroup>
            <a class="product-details__title h2" href="${product_data.product_url}" title="${window.theme.strings.viewFullDetails}">${product_data.title }</a>

            ${(edit_mode) ? '' : getRating(product_data)}
          </hgroup>

          <form action="/cart/add" method="post" enctype="multipart/form-data">
            <div class="product-details__pricing" data-product-pricing>
              ${getProductPrice(same_color_variants[0])}
              ${(edit_mode) ? '' : getAfterpay(same_color_variants[0])}
            </div>

            ${getPromoMessageAndPrice(product_data, 'price')}
            ${getFinalSale(product_data)}
            ${getHeavy(product_data)}
            ${getPromoMessageAndPrice(product_data, 'message')}

            <div class="product-options">
              ${getFitsOptions()}
              <div data-selected-color data-selected-color-label class="product-option__label" aria-live="assertive"><span class="color-name"></span></div>
              ${getColorOptions(all_variants, same_color_variants, swatches_data)}
              ${getSizesOptions(same_color_variants)}
            </div>

            ${getSizesOptionsList(all_variants)}

            <div class="product-quantity quantity">
              <div class="quantity__fields">
                <button type="button" class="quantity__change" aria-label="Decrement quantity" data-quickview-quantity-decrement>-</button>
                <label for="Quantity" class="visually-hidden">Quantity</label>
                <input type="number" class="quantity__input" aria-label="Quantity" id="Quantity" name="quantity" value="1" min="1" autocomplete="off" readonly />
                <button type="button" class="quantity__change" aria-label="Increment quantity" data-quickview-quantity-increment>+</button>
              </div>
            </div>

            ${getActions(product_data, same_color_variants[0], edit_mode)}

            <div class="product-actions__error" data-quickview-add-to-cart-error></div>
          </form>
        </div>

        ${(edit_mode) ? '' : productExtra(product_data)}

        <div class="product-actions__view-details" tabindex="0" data-quickview-view-details data-quickview-view-details-base-link="${product_data.product_url}">
          <a href="${product_data.product_url}" title="${window.theme.strings.viewFullDetails}">${window.theme.strings.viewFullDetails}</a>
        </div>
      </div>
    `;

    // We need to have the close button before .modal__content
    const close_html = $ql.find('.close-modal')[0].outerHTML;
    $ql.find('.close-modal').remove();
    $ql.prepend(close_html);

    $ql.find('.modal__content').html($html);

    return null;

  } catch (error) {
    console.log('Product html error', error);
    $ql.find('.modal__content').html(`An error occured. The product cannot be displayed within the quick view.`);
    return null;
  }
};

const populateProductDetailsMobile = (product_data, selected_color, edit_mode = false) => {
  const $ql = $('#quicklook-modal-mobile');

  try {
    // console.log(`Populate product details ${JSON.stringify(product_data)}`);

    if (product_data === null) {
      throw new Error('No product data');
    }

    if (product_data.handle.includes('gift-card')) {
      throw new Error('Gift cards not supported');
    }

    const same_color_variants_edges = getSameColorVariants(selected_color);

    if (same_color_variants_edges === null) {
      throw new Error('[ASTR] No variants with the selected color');
    }

    const swatches_data = (product_data.astrSwatches === null) ? [] : JSON.parse(product_data.astrSwatches.value.split('\"').join('"'));
    const same_color_variants = same_color_variants_edges.map(edge => edge.node);
    const all_variants = product_data.variants.edges.map(edge => edge.node);

    // console.log('swatches_data', swatches_data);
    // console.log('same_color_variants', same_color_variants);
    // console.log('all_variants', all_variants);

    const $html = `
      <div class="close-modal" role="button" data-close-quickview-mobile></div>

      <div class="quickview-mobile-content" data-quickview-mobile-content>
        <div class="quickview-mobile-content__images" data-quickview-mobile-images>
          <div class="quickview-mobile-content__image-container">
            ${(window.theme.breakpoints.current === 'mobile') ? getWishlistButton(product_data, same_color_variants[0]) : ''}
            ${(product_data.images === null || typeof product_data.images.edges === 'undefined' || !product_data.images.edges.length) ? '' : variantImages(same_color_variants[0], 1)}
          </div>
        </div>

        <div class="quickview-mobile-content__details" data-quickview-mobile-details>
          <hgroup>
            <a class="quickview-mobile-content__title h2" href="${product_data.product_url}" title="${window.theme.strings.viewFullDetails}">${product_data.title }</a>

            ${(edit_mode) ? '' : getRating(product_data)}
          </hgroup>

          <form action="/cart/add" method="post" enctype="multipart/form-data">
            <div class="quickview-mobile-content__pricing" data-product-pricing>
              ${getProductPrice(same_color_variants[0])}
              ${getAfterpay(same_color_variants[0])}
            </div>

            ${getPromoMessageAndPrice(product_data, 'price')}
            ${getFinalSale(product_data)}
            ${getHeavy(product_data)}
            ${getPromoMessageAndPrice(product_data, 'message')}

            <div class="product-options">
              <div data-selected-color data-selected-color-label class="product-option__label" aria-live="assertive"><span class="color-name"></span></div>
              ${getColorOptions(all_variants, same_color_variants, swatches_data)}
              <div data-selected-size data-selected-size-label class="product-option__label" aria-live="assertive">Choose your size</div>
              ${getSizesOptions(same_color_variants)}
            </div>

            ${getSizesOptionsList(all_variants)}

            <div class="product-quantity quantity">
              <div class="quantity__fields">
                <button type="button" class="quantity__change" aria-label="Decrement quantity" data-quickview-quantity-decrement>-</button>
                <label for="Quantity" class="visually-hidden">Quantity</label>
                <input type="number" class="quantity__input" aria-label="Quantity" id="Quantity" name="quantity" value="1" min="1" autocomplete="off" readonly />
                <button type="button" class="quantity__change" aria-label="Increment quantity" data-quickview-quantity-increment>+</button>
              </div>
            </div>

            ${getActions(product_data, same_color_variants[0], edit_mode)}

            <div class="product-actions__error" data-quickview-add-to-cart-error></div>
          </form>

          <div class="product-actions__view-details" tabindex="0" data-quickview-mobile-view-details data-quickview-mobile-view-details-base-link="${product_data.product_url}">
            <a href="${product_data.product_url}" title="${window.theme.strings.viewFullDetails}">${window.theme.strings.viewFullDetails}</a>
          </div>
        </div>
      </div>
    `;

    $ql.html($html);

    return null;

  } catch (error) {
    console.log('Product html error', error);
    $ql.html(`An error occured. The product cannot be displayed within the quick view.`);
    return null;
  }
};

// Re-open the search suggestions since opening the modal lost the focus
const reOpenSearchSuggestions = () => {
  if ($('body').hasClass('quicklook-modal-search-suggestions-opened')) {
    $('body').removeClass('quicklook-modal-search-suggestions-opened');

    $('[data-overlay-search-form] .aa-Input').trigger('focus');
    $('[data-overlay-search-form] .aa-Input').trigger('click');
  }
};

const closeQuicklookMobile = () => {
  const $ql = $('#quicklook-modal-mobile');
  $ql.removeClass('active');
  $('[data-full-overlay]').removeClass('active');
  $('body').removeClass('edit-cart');
  enableBodyScroll($('#quicklook-modal-mobile')[0]);
  reOpenSearchSuggestions();
};

// Making sure we're only coming from a Nosto functionality (not cart edit, lookbook, Shopify product lists, etc.)
// To do: non recommendation Nosto items
const viewAttribution = ($item) => {
  const is_cart_edit = (typeof $item.data('cart-item-edit') !== 'undefined');
  const is_nosto_tile = ($item.closest('.nosto_element').length >= 1);

  if (is_cart_edit) {
    return;
  }

  const $tile = $item.closest('.product-tile');
  const selected_product_id = $tile.data('product-id');

  // From recommendations
  if (is_nosto_tile) {
    const recommendation_id = $item.closest('.nosto_element').attr('id');
    nostoRecommendedProductViewEvent(selected_product_id, recommendation_id, false, true);
    return;
  }

  // From search / PLPs
  let click_location = '';

  if ($tile.closest('[data-collection-grid]').length) {
    click_location = 'category';
  }

  if ($tile.closest('[data-overlay-search-results]').length) {
    click_location = 'serp';
  }
  
  if ($tile.closest('.ns-autocomplete-product-tile').length) {
    click_location = 'autocomplete';
  }

  if (click_location === '') {
    return;
  }

  console.log('[ASTR] Quicklook', click_location, selected_product_id, $tile.find('.product-tile__image').attr('href'));
  nostoRecordSearchClickEvent(click_location, selected_product_id, $tile.find('.product-tile__image').attr('href'));
};

export default () => {
  // Desktop button ONLY
  $(document).on('click', '[data-quicklook-button]', async (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const $item = $(e.currentTarget);
    const $ql = $('#quicklook-modal');

    const is_search_suggestions = (document.querySelector('.aa-Panel') !== null);
    const is_cart_edit = (typeof $item.data('cart-item-edit') !== 'undefined');
    // console.log('is_cart_edit', is_cart_edit);

    const $tile = (is_cart_edit) ? null : $item.closest('.product-tile');

    // Resize the modal and image area for desktop screens where modal height doesn't fit
    const modal_w = (is_cart_edit) ? 580 : 1000;
    const modal_h = (is_cart_edit) ? 445 : 945;
    const window_h = $(window).height();
    const modal_img_w = 576;
    const ratio = window_h / modal_h;
    const new_modal_w = modal_w * ratio;
    const new_modal_img_w = modal_img_w * ratio;
    const selected_product_id = (is_cart_edit) ? $item.closest('.cart-item').data('product-id') : $tile.data('product-id');

    // Needs to be added before to set sizes correctly
    if (is_cart_edit) {
      $('body').addClass('edit-cart');
    }

    $ql.addClass('loading');

    closeSliderCart();

    $ql.find('.modal__content').empty();
    // $ql.find('.modal__content').html(`<img src="${$ql.find('[data-loader]').data('loader')}" width="100" alt="Loading..." />`);

    $($item.data('modal')).modal({
      fadeDuration: 250,
      fadeDelay: 0.80,
    });

    $($item.data('modal')).off($.modal.BEFORE_OPEN);
    $($item.data('modal')).on($.modal.BEFORE_OPEN, () => {
      if (!is_cart_edit) {
        $tile.addClass('active');
      }

      if (is_search_suggestions) {
        $('body').addClass('quicklook-modal-search-suggestions-opened');
      }
      
      $('#quicklook-modal').removeAttr('style');

      if ((window_h < modal_h + 20) && !is_cart_edit) {
        $('#quicklook-modal').css({ 'min-height': `${window_h - 40}px`, 'max-height': `${window_h - 40}px`, 'max-width': `${new_modal_w}px` });
      }
    });

    $($item.data('modal')).off($.modal.OPEN);
    $($item.data('modal')).on($.modal.OPEN, () => {
      // [ADA]
      $('#quicklook-modal .close-modal').attr('role', 'button');
      $('#quicklook-modal .close-modal').trigger('focus');
      $('#quicklook-modal .close-modal').removeAttr('style');

      // We don't know the width of the modal, it can be smaller on tablet
      // console.log(`opacity: 1; left: calc(50vw + ${$('[data-quicklook-modal]').width() / 2}px - 25px) !important;`)
      $('#quicklook-modal .close-modal').attr('style', `opacity: 1; left: calc(50vw + ${$('[data-quicklook-modal]').width() / 2}px - 40px) !important;`);

      // Send the product view event to Algolia when coming from a PLP/Search overlay
      // const algolia_params = URI($item.parent().find('a').attr('href'));
      // if (typeof algolia_params.query.apid !== 'undefined') {
      //   algoliaViewedItemEvent([algolia_params.query.apid], 'QV');
      // }

      // View attribution to Nosto (Recommendation or PLP/Search overlay)
      viewAttribution($item);
    });

    $($item.data('modal')).off($.modal.AFTER_CLOSE);
    $($item.data('modal')).on($.modal.AFTER_CLOSE, () => {
      if (!is_cart_edit) {
        $tile.removeClass('active');
      }
      $ql.find('.modal__content').empty();

      $('body').removeClass('edit-cart');

      reOpenSearchSuggestions();
    });

    // Load the product from the frontend api
    const product_details = await loadProductDetailsFromStorefrontAPI(selected_product_id);

    if (product_details === null) {
      $ql.find('.modal__content').html(`An error occured. The product cannot be displayed within the quick view.`);
      return;
    }
    
    const metaobject_id = window.Shopify.shop.includes('staging') ? '77458997425' : '2725314736';
    product_details.returnsShipping = await loadMetaobject(metaobject_id);

    let selected_color = (is_cart_edit) ? $item.closest('.cart-item').find('[data-item-color]').data('color') : $tile.find('[data-color-swatch].active').data('color-value');
    selected_color = selected_color.trimStart().trimEnd();

    let selected_size = (is_cart_edit) ? $item.closest('.cart-item').find('[data-item-size]').data('size') : '';
    selected_size = selected_size.trimStart().trimEnd();

    const is_plus = selected_color.includes('Plus Size -');

    // Remove the opposite fit variants
    const product_details_variants = product_details.variants.edges.filter((edge) => {
      return (is_plus) ? (edge.node.title.includes('Plus Size -')) : !(edge.node.title.includes('Plus Size -'));
    });

    product_details.variants.edges = product_details_variants;

    window.theme.quickview.product = product_details;

    // console.log('is_plus: ', is_plus, ' // selected_color: ', selected_color, ' // selected_size: ', selected_size);

    // const product_rating = await loadProductRatingFromStorefrontAPI(product_details.handle);

    product_details.product_url = getProductURL(product_details.handle);

    // Build and append HTML
    populateProductDetails(product_details, selected_color, is_cart_edit);

    // Just to be safe as DOM from code injection can take a few ms to render
    window.setTimeout(() => {
      if (!is_cart_edit) {
        if (document.querySelectorAll('#quicklook-modal .product-extra-v3 [role=tablist]').length > 0) {
          new TabsAutomatic(document.querySelectorAll('#quicklook-modal .product-extra-v3 [role=tablist]')[0]);
        }
        
        // Wishlist
        initWishlistQuickviewOpen(product_details);
  
        const product_id = _.last(product_details.id.split('/'));
        const quickview_opened = new CustomEvent('quickview:loaded', { bubbles: true });
        quickview_opened.data = { detail: { productId: product_id } };
        document.dispatchEvent(quickview_opened);
      }

      // const same_color_variants_edges = getSameColorVariants(selected_color);
      initProductOptions(product_details.variants.edges, selected_color, selected_size);

      if ((window_h < modal_h + 20) && !is_cart_edit) {
        $('#quicklook-modal .close-modal').attr('style', `left: calc(50vw + ${new_modal_w / 2}px - 70px) !important`);
        $('#quicklook-modal [data-product-scrollable-images]').css({ 'max-width': `${new_modal_img_w - 30}px` });
      }

      if (is_cart_edit) {
        const qty = $item.closest('.cart-item').find('.quantity__input').first().val();
        $('#quicklook-modal .quantity__input').val(Number(qty));
        $('[data-quickview-update]').data('initial-variant-id', $item.closest('.cart-item').data('variant-id'));
        $('[data-quickview-update]').data('initial-variant-qty', qty);
      }
    }, 100);
  });

  initWishlist();

  $(document).on('click', '[data-quickview-product-option-color]', (e) => {
    const $item = $(e.currentTarget);
    selectColorQuicklook($item);
  });

  $(document).on('keypress', '[data-quickview-product-option-color]', (e) => {
    const key = e.which;
    // Enter / spacebar
    if (key === 13 || key === 32) {
      const $item = $(e.currentTarget);
      $item.trigger('click');
    }
  });

  $(document).on('click', '[data-quickview-product-option-size]', (e) => {
    const $item = $(e.currentTarget);
    selectSizeQuicklook($item);
  });

  $(document).on('keypress', '[data-quickview-product-option-size]', (e) => {
    const key = e.which;
    // Enter / spacebar
    if (key === 13 || key === 32) {
      const $item = $(e.currentTarget);
      $item.trigger('click');
    }
  });

  $(document).on('click focus', '[data-quickview-buy-now]', (e) => {
    e.preventDefault();
    e.stopPropagation();
    const $item = $(e.currentTarget);

    if ($item.prop('disabled')) {
      return;
    }

    // https://community.shopify.com/c/shopify-design/cart-use-permalinks-to-pre-load-the-cart/td-p/613702#adding-a-buy-this-link-to-a-blog-post
    // http://yourstore.com/cart/#{variant_id}:#{quantity}(,...)
    window.location.href = `${window.Shopify.routes.root}cart/${$('[data-quickview-product-select]').val()}:1`;
  });

  // Mobile button ONLY
  $(document).on('click touchend', '[data-quicklook-button-mobile]', async (e) => {
    const $item = $(e.currentTarget);

    if ((window.theme.breakpoints.current !== 'mobile') || $item.hasClass('unavailable')) {
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    const $ql = $('#quicklook-modal-mobile');

    const is_cart_edit = (typeof $item.data('cart-item-edit') !== 'undefined');
    // console.log('is_cart_edit', is_cart_edit);

    if (is_cart_edit) {
      $('body').addClass('edit-cart');
    }

    const $tile = (is_cart_edit) ? null : $item.closest('.product-tile');

    closeSliderCart();
    $ql.empty();

    $ql.addClass('active');
    $('[data-full-overlay]').addClass('active');

    const selected_product_id = (is_cart_edit) ? $item.closest('.cart-item').data('product-id') : $tile.data('product-id');
    // const selected_algolia_id = (is_cart_edit) ? $item.closest('.cart-item').data('product-algolia-id') : $tile.data('product-algolia-id');

    // Load the product from the frontend api
    const product_details = await loadProductDetailsFromStorefrontAPI(selected_product_id);

    if (product_details === null) {
      $ql.find('.modal__content').html(`An error occured. The product cannot be displayed within the quick view.`);
      return;
    }

    window.theme.quickview.product = product_details;

    let selected_color = (is_cart_edit) ? $item.closest('.cart-item').find('[data-item-color]').data('color') : $tile.find('[data-color-swatch].active').data('color-value');
    selected_color = selected_color.trimStart().trimEnd();

    let selected_size = (is_cart_edit) ? $item.closest('.cart-item').find('[data-item-size]').data('size') : '';
    selected_size = selected_size.trimStart().trimEnd();

    product_details.product_url = getProductURL(product_details.handle);

    // Build and append HTML
    populateProductDetailsMobile(product_details, selected_color, is_cart_edit);

    // Just to be safe as DOM from code injection can take a few ms to render
    window.setTimeout(() => {  
      if (!is_cart_edit) { 
        // Wishlist  
        initWishlistQuickviewMobileOpen(product_details);

        const product_id = _.last(product_details.id.split('/'));
        const quickview_opened = new CustomEvent('quickview-mobile:loaded', { bubbles: true });
        quickview_opened.data = { detail: { productId: product_id } };
        document.dispatchEvent(quickview_opened);

        // View attribution to Nosto (Recommendation or PLP/Search overlay)
        viewAttribution($item);
      }

      initProductOptions(product_details.variants.edges, selected_color, selected_size);

      disableBodyScroll($('#quicklook-modal-mobile')[0]);

      const is_search_suggestions = (document.querySelector('.aa-Panel') !== null);
      if (is_search_suggestions) {
        $('body').addClass('quicklook-modal-search-suggestions-opened');
      }

      if (is_cart_edit) {
        const qty = $item.closest('.cart-item').find('.quantity__input').first().val();
        $('#quicklook-modal-mobile .quantity__input').val(Number(qty));
        $('[data-quickview-update]').data('initial-variant-id', $item.closest('.cart-item').data('variant-id'));
        $('[data-quickview-update]').data('initial-variant-qty', qty);
      }
    }, 100);
  });

  $(document).on('click touchend', '[data-full-overlay]', (e) => {
    e.preventDefault();
    e.stopPropagation();

    closeQuicklookMobile();
  });

  $(document).on('click touchend', '[data-close-quickview-mobile]', (e) => {
    e.preventDefault();
    e.stopPropagation();

    closeQuicklookMobile();
  });

  $(document).on('click touchend', '[data-quickview-mobile] [data-quickview-add-to-cart]', (e) => {
    const $item = $(e.currentTarget);

    if ($item.attr('disabled') === 'disabled') {
      return;
    }

    window.setTimeout(() => {
      closeQuicklookMobile();
    }, 1500);
  });

  // First version to keep as reference during the development of v2
  /*
  $(document).on('click', '[data-quicklook-button]', (e) => {
    e.preventDefault();
    const $item = $(e.currentTarget);
    const $ql = $('#quicklook-modal');

    $ql.addClass('loading');

    closeSliderCart();
    $ql.find('.modal__content').empty();
    $ql.find('.modal__content').html(`<img src="${$ql.find('[data-loader]').data('loader')}" width="100" alt="Loading..." />`);

    const current_scrolltop = $(document).scrollTop();

    $($item.data('modal')).modal({
      fadeDuration: 250,
      fadeDelay: 0.80,
    });

    $($item.data('modal')).on($.modal.BEFORE_OPEN, () => {
      $('html, body').scrollTop(current_scrolltop);
      headerPosition(current_scrolltop);
      $item.addClass('active');
    });

    $($item.data('modal')).on($.modal.AFTER_CLOSE, () => {
      $('html, body').scrollTop(current_scrolltop);
      headerPosition(current_scrolltop);
      $item.removeClass('active');
    });

    // Load the html from the product page
    let product_url = `${window.location.origin}${$item.closest('.product-tile__image').attr('href')}`;

    if ($('.template-cart').length) {
      product_url = `${window.location.origin}${$item.closest('[data-cart-item]').data('product-url')}`;
    }

    $.ajax({
      url: product_url,
      method: 'get',
      dataType: 'html',
    }).done((html) => {
      $ql.removeClass('loading');

      const overview = $(html).find('#shopify-section-product-overview').html();
      $ql.find('.modal__content').html(overview);

      // Init the wishlist app
      if ($('.swym-add-to-wishlist-view-product').length) {
        _swat.initializeActionButtons('.swym-add-to-wishlist-view-product');
      }

      if ($('.template-cart').length && !$('[data-add-to-cart-available]').hasClass('visually-hidden')) {
        $('[data-add-to-cart-available]').html('Replace');
        $('[data-add-to-cart]').data('replace', true);
      }

      initSelectVariant(product_url);

      // if (window.theme.isZonos && typeof zonos !== 'undefined') {
      //   zonos.displayCurrency();
      // }
    });
  });

  $(window).on('breakpointHasChanged', (e, current_breakpoint) => {
    if ($('#quicklook-modal').is(':visible') && current_breakpoint === 'mobile') {
      $('#quicklook-modal [rel="modal:close"]').trigger('click');
    }
  });
  */
};
